import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { Logout } from '@mui/icons-material';
import { getUserMenuItemsByGroup } from 'config/navigationConfig';
import { UserType } from 'types/types';

export type NavigationMenuItem = {
  id: string;
  label: string;
  icon: React.ReactElement | null;
  action: () => void;
  group?: string;
};

export function createUserMenuItems(
  userType: UserType | null,
  isAdmin: boolean,
  navigate: NavigateFunction,
  logout: () => void
): NavigationMenuItem[] {
  const groups = getUserMenuItemsByGroup(userType, isAdmin);
  const items: NavigationMenuItem[] = [];

  addGroupItems(items, groups.profile, 'profile', navigate, true);
  addDivider(items, groups.system.length > 0);
  addGroupItems(items, groups.account, 'account', navigate);
  addDivider(items, groups.system.length > 0);
  addGroupItems(items, groups.admin, 'admin', navigate);
  addDivider(items, groups.admin.length > 0);
  addSystemItems(items, groups.system, navigate, logout);
  addGroupItems(items, groups.other, 'other', navigate);

  return items;
}

function addGroupItems(
  items: NavigationMenuItem[],
  groupItems: ReturnType<typeof getUserMenuItemsByGroup>['profile'],
  group: string,
  navigate: NavigateFunction,
  replace = false
): void {
  groupItems.forEach(item => {
    if (item.divider) return;
    items.push({
      id: item.id,
      label: item.label as string,
      icon: item.icon || null,
      action: () => item.path && navigate(item.path.replace(/:.*$/, ''), { replace }),
      group,
    });
  });
}

function addSystemItems(
  items: NavigationMenuItem[],
  groupItems: ReturnType<typeof getUserMenuItemsByGroup>['system'],
  navigate: NavigateFunction,
  logout: () => void
): void {
  groupItems.forEach(item => {
    if (item.id === 'logout') {
      items.push({
        id: 'logout',
        label: 'Logout',
        icon: <Logout fontSize="small" />,
        action: () => {
          logout();
          navigate('/');
        },
        group: 'system',
      });
    } else if (!item.divider) {
      items.push({
        id: item.id,
        label: item.label as string,
        icon: item.icon || null,
        action: () => item.path && navigate(item.path.replace(/:.*$/, '')),
        group: 'system',
      });
    }
  });
}

function addDivider(items: NavigationMenuItem[], condition: boolean): void {
  if (!condition || items.length === 0) return;
  items.push({
    id: `divider-${items.length}`,
    label: '',
    icon: null,
    action: () => undefined,
    group: 'divider',
  });
}
